import { styled } from '@mui/material/styles';
import { Paper, Box, Typography } from '@mui/material';

export const StyledPaper = styled(Paper)(({ theme }) => ({
  height: '100%',
  width: '100%',
  backgroundColor: '#252526',
  color: '#ffffff',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  borderRadius: theme.spacing(1.5), // rounded corners
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
  transition: 'all 0.3s ease',
}));

export const ContentWrapper = styled(Box)(({ theme }) => ({
  flex: 1,
  overflow: 'auto',
  padding: theme.spacing(2.5), // improved padding
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2.5),
  width: '100%',

  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#1e1e1e',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#424242',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: '#686868',
  },
}));

export const SectionContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  backgroundColor: '#1e1e1e',
  borderRadius: theme.spacing(1.2),
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
  boxShadow: 'inset 0 0 0 1px rgba(255, 255, 255, 0.05)',

  '.MuiDataGrid-root': {
    flex: 1,
    border: 'none',
    width: '100%',
    '.MuiDataGrid-cell': {
      borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
    },
    '.MuiDataGrid-columnHeaders': {
      backgroundColor: '#2e2e2e',
      color: '#ffffff',
      fontWeight: 'bold',
      borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
    },
    '.MuiDataGrid-row:nth-of-type(odd)': {
      backgroundColor: '#1f1f1f',
    },
    '.MuiDataGrid-row:nth-of-type(even)': {
      backgroundColor: '#292929',
    },
    '.MuiDataGrid-row:hover': {
      backgroundColor: '#3a3a3a',
    },
  },
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  fontWeight: 600,
  marginBottom: theme.spacing(1),
  color: '#ffffff',
  fontFamily: 'Poppins, sans-serif',
}));

export const ActionButton = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  alignItems: 'center',
  justifyContent: 'flex-end',
  '& .MuiIconButton-root': {
    padding: 4,
    color: '#ffffff',
    backgroundColor: 'rgba(255, 255, 255, 0.04)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.12)',
    },
  },
  '& .MuiSvgIcon-root': {
    fontSize: '1.2rem',
  },
}));
